import { ToastContext } from "components/dashboard/common/Toast/context/ToastContextProvider";
import { ConfirmAction, Modal } from "components/ui";
import { useContext, useState } from "react";
import { apiRoute } from "services";
import API from "services/lib/api";
import { dataQueryStatus } from "utils";
import { getErrorMessage } from "utils/helper";

const { ERROR } = dataQueryStatus;

const DetachCannedMessage = ({
    closeModal,
    showModal,
    handleSuccess,
    selectedCannedResourceId,
    guideFlowId,
}) => {
    const [loading, setLoading] = useState(false);
    const toastMessage = useContext(ToastContext);

    const detachCannedResource = async () => {
        try {
            setLoading(true);

            const url = apiRoute.detachCannedGuideFlow(
                guideFlowId,
                selectedCannedResourceId
            );
            const res = await API.post(url);

            if (res.status === 201) {
                const { message } = res.data;
                toastMessage(message);
                handleSuccess?.();
                closeModal();
            }
        } catch (err) {
            setLoading(false);
            const message = getErrorMessage(err);
            toastMessage(message, ERROR);
        }
    };

    return (
        <Modal show={showModal} close={closeModal}>
            <ConfirmAction
                title='Are you sure you want to detach this canned resource'
                loading={loading}
                close={closeModal}
                handleYesClick={detachCannedResource}
            />
        </Modal>
    );
};

export default DetachCannedMessage;
